module.exports = __webpack_public_path__ + "assets/cb75767d1e52d4eb4671fd47fb91763d.mp3";